import { useState, type FormEvent } from "react";
import { Button } from "../ui/Button";

interface TextInputProps {
  onSubmit: (text: string) => void;
  disabled?: boolean;
}

export function TextInput({ onSubmit, disabled }: TextInputProps) {
  const [text, setText] = useState("");

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (text.trim()) {
      onSubmit(text.trim());
      setText("");
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="What did you work on today? Share updates, wins, learnings..."
        className="w-full resize-none rounded-lg border border-slate-300 px-4 py-3 text-sm placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
        rows={4}
        disabled={disabled}
      />
      <div className="flex items-center justify-between">
        <span className="text-xs text-slate-400">{text.length} characters</span>
        <Button type="submit" disabled={disabled || !text.trim()}>
          Submit check-in
        </Button>
      </div>
    </form>
  );
}
